import type { Strings } from './strings.js';

export const ru: Strings = {
  languageName: 'Русский',
  welcome: 'Добро пожаловать',
  chooseReason: 'Чем мы можем вам помочь?',
  back: 'Назад',
  cancel: 'Отмена',
  next: 'Далее',
  submit: 'Отправить регистрацию',
  submitting: 'Отправка',
  yourDetails: 'Ваши данные',
  optional: 'необязательно',
  required: 'обязательное поле',
  requiredHint: 'Пожалуйста, заполните отмеченные поля.',
  fieldRequired: 'Пожалуйста, заполните это поле.',
  fieldInvalid: 'Пожалуйста, проверьте эти данные.',
  pleaseSelect: 'Пожалуйста, выберите',
  search: 'Поиск',
  noResults: 'Ничего не найдено',
  noOptions: 'Сейчас здесь нет доступных вариантов. Пожалуйста, обратитесь к сотруднику.',
  stepReason: 'Цель визита',
  stepDetails: 'Данные',
  stepDone: 'Готово',
  thankYou: 'Спасибо!',
  submitted: 'Ваша регистрация отправлена.',
  waitHint: 'Пожалуйста, присядьте. Вас скоро вызовут.',
  scanFormHint: 'Отсканируйте код телефоном, чтобы взять форму с собой.',
  ticketNumber: 'Ваш номер в очереди',
  queuedTitle: 'Спасибо!',
  queuedHint: 'Ваша регистрация сохранена и будет отправлена автоматически. Пожалуйста, присядьте.',
  errorTitle: 'К сожалению, не получилось',
  errorHint: 'Пожалуйста, попробуйте ещё раз или обратитесь к сотруднику.',
  tryAgain: 'Попробовать ещё раз',
  startOver: 'Начать заново',
  closedTitle: 'Наш офис сейчас закрыт',
  closedHint: 'Вы всё равно можете зарегистрироваться - мы свяжемся с вами в следующий рабочий день.',
  closedCallUs: 'Связаться с нами по телефону',
  continueAnyway: 'Всё равно зарегистрироваться',
  appointmentQuestion: 'У вас назначена встреча?',
  appointmentYes: 'Да, у меня назначена встреча',
  appointmentNo: 'Нет, встреча не назначена',
  visitingWhom: 'К кому вы пришли?',
  privacyTitle: 'Защита данных',
  privacyAccept: 'Я ознакомился с уведомлением о защите данных.',
  privacyRequired: 'Пожалуйста, подтвердите уведомление о защите данных.',
  offline: 'Не в сети',
  offlineHint: 'Нет соединения - регистрации сохраняются и будут отправлены позже.',
  pendingCount: 'сохранённых регистраций',
  idleWarning: 'Введённые данные скоро будут удалены.',
  pairTitle: 'Подключить планшет',
  pairHint: 'Пожалуйста, введите код сопряжения из администрирования.',
  pairPlaceholder: 'ABCD-1234',
  pairButton: 'Подключить',
  pairError: 'Код недействителен или истёк.',
  pairSuccess: 'Планшет подключён',
  loading: 'Загрузка',
  notConfigured: 'Типы визитов не настроены',
  notConfiguredHint: 'Пожалуйста, обратитесь к сотруднику.',
  adminLink: 'Администрирование',
  pairCodeHint:
    'Код создаётся в администрировании в разделе «Площадки и планшеты» и действует ограниченное время.',
  setupTitle: 'Ещё не настроено',
  setupText:
    'Эта система ещё не настроена. Мастер настройки создаёт администратора, организацию, площадку и первый планшет.',
  setupButton: 'Начать настройку',
  setupAfter: 'После этого здесь автоматически появится поле для кода сопряжения.',
};
